import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaChevronDown } from 'react-icons/fa';

// Animações
const arrowBounce = keyframes`
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(5px); }
  60% { transform: translateY(3px); }
`;

// Container para o texto e seta
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5rem auto 3rem;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;

// Texto estilizado
const InfoText = styled.span`
  font-family: 'Orbitron', sans-serif;
  font-size: 14px;
  letter-spacing: 1px;
  color: rgba(100, 182, 255, 0.8);
  margin-bottom: 8px;
  text-transform: uppercase;
  transition: color 0.3s ease;
  
  ${ButtonContainer}:hover & {
    color: rgba(0, 255, 255, 0.9);
  }
`;

// Seta estilizada
const Arrow = styled(FaChevronDown)`
  color: rgba(100, 182, 255, 0.7);
  font-size: 14px;
  animation: ${arrowBounce} 2s infinite ease-in-out;
  
  ${ButtonContainer}:hover & {
    color: rgba(0, 255, 255, 0.9);
  }
`;

const MoreInfoButton = ({ onClick }) => {
  return (
    <ButtonContainer onClick={onClick}>
      <InfoText>Mais informações</InfoText>
      <Arrow />
    </ButtonContainer>
  );
};

export default MoreInfoButton;
